<template>
  <div class="chart-field" v-loading="chartLoading">
    <div class="chart-title" @click="showDetail">{{ title }} ></div>
    <div v-show="chartData.dataTrendList.length > 0" style="height: 400px">
      <div style="height: 400px" ref="chartRef"></div>
    </div>
    <div v-if="chartData.dataTrendList.length === 0">
      <el-empty style="margin-top: 20px" description="暂无数据"></el-empty>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {
  getInstallTrendData,
  getCostTrendData,
  getInComeTrendData,
  getPurchaseIncomeTrendData,
  getArpuTrendData,
} from "@/api/bi-board";
import { sortBy, reverse, join } from "lodash";
export default {
  components: {},
  props: {
    formSearch: Object,
    title: String,
    fieldKey: String,
  },
  data() {
    return {
      chartLoading: false,
      myChart: null,
      chartData: {
        dataTrendList: [],
      },
    };
  },

  computed: {},

  methods: {
    setLoading(loading) {
      this.chartLoading = loading;
    },
    getCharts() {
      this.chartLoading = true;
      const {
        formdate,
        geo,
        afid,
        platform,
        team,
        mediaList,
        accountGroupCodes,
      } = this.formSearch;
      let api = null;
      // 支出趋势
      if (
        ["productOutlay", "countryOutlay", "channelOutlay"].includes(
          this.fieldKey
        )
      ) {
        api = getCostTrendData;
        // 收入趋势
      } else if (
        ["productIncome", "countryIncome", "channelIncome"].includes(
          this.fieldKey
        )
      ) {
        api = getInComeTrendData;
        // 内购收入趋势
      } else if (
        ["countryPurchaseIncome", "productPurchaseIncome"].includes(
          this.fieldKey
        )
      ) {
        api = getPurchaseIncomeTrendData;
        // Arpu
      } else if (
        ["countryPurchaseArpu", "countryAdArpu"].includes(this.fieldKey)
      ) {
        api = getArpuTrendData;
        // 新增趋势
      } else {
        api = getInstallTrendData;
      }
      let params = {
        dateStart: formdate[0],
        dateEnd: formdate[1],
        top: this.topType,
        geo: geo.join(",") || null,
        afid: afid.join(",") || null,
        team: team.join(",") || null,
        platform,
        mediaList,
        dimension: this.fieldKey.includes("product")
          ? 1
          : this.fieldKey.includes("country")
          ? 2
          : 3,
        accountGroupCodes: accountGroupCodes.length ? [...accountGroupCodes] : undefined,
      };
      if (["countryPurchaseArpu", "countryAdArpu"].includes(this.fieldKey)) {
        params.type = this.fieldKey === "countryPurchaseArpu" ? 2 : 1;
      }
      return api(params).then((res) => {
        this.chartData = JSON.parse(JSON.stringify(res.data));
        if (this.chartData?.dataTrendList?.length > 0) {
          setTimeout(() => {
            this.myChart?.dispose();
            let chartDom = this.$refs.chartRef;
            let myChart = echarts.init(chartDom);
            window.onresize = myChart.resize;
            this.myChart = myChart;
            this.renderData();
          }, 0);
        } else {
          this.chartLoading = false;
        }
      }).catch((error) => {
        console.error('趋势图加载失败:', error);
      }).finally(() => {
        this.chartLoading = false;
      });
    },
    renderData() {
      this.chartLoading = true;
      const key = this.fieldKey.includes("product")
        ? "appName"
        : this.fieldKey.includes("country")
        ? "geo"
        : "mediaSource";
      let option = {
        color: [
          "#FFB6C1",
          "#DC143C",
          "#F0E68C",
          "#6B8E23",
          "#8B008B",
          "#6495ED",
          "#00BFFF",
          "#00FA9A",
          "#FFA500",
          "#FF4500",
        ],
        tooltip: {
          trigger: "axis",
          appendToBody: true,
          formatter: (params) => {
            // params为悬浮框上的全部数据
            const newParams = [];
            let paramsData = sortBy(params, "value"); // 根据value值升序，sortBy为lodash的方法
            paramsData = reverse(paramsData); // 将数据降序，reverse为lodash的方法
            paramsData.forEach((p) => {
              // p.marker为对应数据线的颜色的圆点
              // p.seriesName为对应数据的数据名称
              // p.value为对应数据的值
              const cont =
                "<div style='display: flex;height: 5px'><span style='flex: 1'>" +
                p.marker +
                " " +
                p.seriesName +
                ": " +
                "</span>" +
                "<span style='text-align: right;margin-left: 16px;font-weight: 600'>" +
                p.value +
                "</span></div>" +
                "<br/>";
              newParams.push(cont);
            });
            return join(newParams, ""); // 这里是需要将数组转化成字符串显示，如果不转化，每个数据前面都会出现一个逗号（，），join为lodash的方法
          },
        },
        legend: {
          data: this.chartData.dataTrendList.map((item) => item[key]),
          bottom: 0,
          itemGap: 3,
          itemWidth: 18,
        },
        grid: {
          left: "80",
          right: "50",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartData.datelist,
        },
        yAxis: {
          type: "value",
        },
        series: this.chartData.dataTrendList.map((item) => {
          return {
            symbol: "none",
            name: item[key],
            type: "line",
            data:
              item.installList ||
              item.incomeList ||
              item.costList ||
              item.purchaseIncomeList ||
              item.arpuList,
          };
        }),
      };
      this.myChart.clear();
      this.myChart.setOption(option);
      this.chartLoading = false;
      this.myChart.resize();
    },
    showDetail() {
      this.$emit("showDetail", { title: this.title, key: this.fieldKey });
    },
  },
};
</script>

<style lang="less" scoped>
.chart-field {
  margin-top: 20px;
  .chart-title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 0px;
    cursor: pointer;
  }
  .chart-title:hover {
    color: #1890ff;
  }
}
</style>
